export default {
  color: 'coral-dark',
  eContent: {
    link: 'campus-resources-video',
    label: 'Campus Resources'
  },
}
